async function getMetadata(url: string) {
  const result = await fetch(`/api/url-parse?${new URLSearchParams({ url })}`);
  return result.json();
}

export default getMetadata;
